import { ClipboardList, Clock, LogOut, ScrollText } from 'lucide-react';

interface SupervisorHomeScreenProps {
  supervisorName: string;
  onGoTasks: () => void;
  onGoClock: () => void;
  onGoTimesheets: () => void;
  onLogout: () => void;
}

export function SupervisorHomeScreen({ supervisorName, onGoTasks, onGoClock, onGoTimesheets, onLogout }: SupervisorHomeScreenProps) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex flex-col items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="flex justify-between items-center mb-8">
          <div className="px-4 py-2 bg-white rounded-lg shadow-sm">
            <span className="text-sm text-gray-600">Logged in as </span>
            <span className="text-sm font-semibold text-indigo-700">{supervisorName}</span>
          </div>
          <button
            onClick={onLogout}
            className="flex items-center gap-2 px-4 py-2 text-gray-700 hover:text-gray-900 bg-white/80 hover:bg-white rounded-lg transition shadow-sm hover:shadow-md"
          >
            <LogOut className="w-5 h-5" />
            <span>Logout</span>
          </button>
        </div>

        <div className="bg-white rounded-2xl shadow-xl p-8">
          <div className="text-center mb-8">
            <h1 className="text-3xl font-bold text-gray-900 mb-2">Home</h1>
            <p className="text-gray-600">What would you like to do?</p>
          </div>

          <div className="space-y-4">
            <button
              onClick={onGoTasks}
              className="w-full flex items-center gap-4 px-6 py-5 bg-indigo-50 hover:bg-indigo-100 border-2 border-indigo-200 hover:border-indigo-400 rounded-xl transition duration-200 text-left"
            >
              <div className="p-3 bg-indigo-600 rounded-xl">
                <ClipboardList className="w-6 h-6 text-white" />
              </div>
              <div>
                <div className="font-semibold text-gray-900 text-lg">Submit Tasks</div>
                <div className="text-sm text-gray-500">Fill in daily task reports</div>
              </div>
            </button>

            <button
              onClick={onGoClock}
              className="w-full flex items-center gap-4 px-6 py-5 bg-emerald-50 hover:bg-emerald-100 border-2 border-emerald-200 hover:border-emerald-400 rounded-xl transition duration-200 text-left"
            >
              <div className="p-3 bg-emerald-600 rounded-xl">
                <Clock className="w-6 h-6 text-white" />
              </div>
              <div>
                <div className="font-semibold text-gray-900 text-lg">Clock In / Clock Out</div>
                <div className="text-sm text-gray-500">Track your work hours</div>
              </div>
            </button>

            <button
              onClick={onGoTimesheets}
              className="w-full flex items-center gap-4 px-6 py-5 bg-violet-50 hover:bg-violet-100 border-2 border-violet-200 hover:border-violet-400 rounded-xl transition duration-200 text-left"
            >
              <div className="p-3 bg-violet-600 rounded-xl">
                <ScrollText className="w-6 h-6 text-white" />
              </div>
              <div>
                <div className="font-semibold text-gray-900 text-lg">Timesheets</div>
                <div className="text-sm text-gray-500">View all operator & supervisor time entries</div>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
